import { render, staticRenderFns } from "./FormDeveloperSeo.vue?vue&type=template&id=23cc877c&scoped=true&lang=pug&"
import script from "./FormDeveloperSeo.vue?vue&type=script&lang=js&"
export * from "./FormDeveloperSeo.vue?vue&type=script&lang=js&"
import style0 from "./FormDeveloperSeo.vue?vue&type=style&index=0&id=23cc877c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cc877c",
  null
  
)

export default component.exports